import axios from 'axios';
const api = axios.create({ baseURL: '/api', withCredentials: true });

api.interceptors.request.use(c => {
  if (['post', 'put', 'patch', 'delete'].includes(c.method)) {
    const csrf = document.cookie.split('; ')
      .find(r => r.startsWith('fa_csrf='))?.split('=')[1];
    if (csrf) c.headers['X-CSRF-Token'] = csrf;
  }
  return c;
});

api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      if (window.location.pathname !== '/') window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export default api;
